import { Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import colors from '../../../styles/_variables.module.scss';
import { PaymentResponse, ServicePaymentSuccess } from '../../../types/paymentResult.types';
import { formatCustomDate, styles } from '../../../utils/receipt.helper';
import CommonReceiptData from '../../CommonReceiptData';

interface ServiceReceiptDetailProps {
  paymentSuccess: PaymentResponse | null;
}

function ServiceReceiptDetail({ paymentSuccess }: ServiceReceiptDetailProps) {
  const { t } = useTranslation();
  const data = paymentSuccess?.data as ServicePaymentSuccess;

  return (
    <>
      <View style={styles.detailHeader}>
        <Text style={styles.headerTitle}>{t('receipt-detail.title')}</Text>
        <Text style={styles.headerSubTitle}>{data?.commerceName?.toUpperCase()}</Text>
        <Text style={styles.text}>{t('verticals.services.receipt-detail.subtitle')}</Text>
        <View style={styles.gap} />
        <Text style={styles.text}>{data?.paymentId}</Text>
        <Text style={{ color: colors.placeholderGrey, fontSize: 12 }}>
          {formatCustomDate(data?.date || '')}
        </Text>
      </View>
      <View style={styles.gap} />
      <View style={styles.horizontalChunkBorder}>
        <Text style={styles.detailText}>Nº Factura</Text>
        <Text>{data?.serviceInvoice}</Text>
      </View>
      <CommonReceiptData
        data={data}
        children={<View style={styles.gap} />}
        country={paymentSuccess?.country}
      />
    </>
  );
}

export default ServiceReceiptDetail;
